/**
 * Values stored in form state (backend / eligibility payload).
 */
export const GROUP_COMPANY_OPTIONS = [
  {
    value: 'yes',
    label:
      'Yes, we are part of a group or owned by a parent company',
  },
  {
    value: 'no',
    label:
      'No, we are not part of a group or owned by a parent company',
  },
  {
    value: 'not_sure',
    label:
      'Not sure; we are still clarifying our group or parent company structure',
  },
];

export function getGroupCompanyLabel(value) {
  const opt = GROUP_COMPANY_OPTIONS.find((o) => o.value === value);
  return opt?.label ?? value ?? '';
}
